import { Loader2 } from 'lucide-react';
import { Text } from '@/components/ui/Text';
import { useContextStore } from '@/lib/session/context-store';

/**
 * Full-screen overlay shown while the active context is switching.
 *
 * Makes a context switch feel like a workspace switch: an OPAQUE cover (not a
 * blur) over the entire app — sidebar, navbar and content — so the user never
 * sees the in-place reset → refetch flicker. It stays up for the whole switch
 * (round-trip + cache reset + refetch of the new root), driven by `isSwitching`,
 * then lifts onto the freshly-loaded root of the new context. Mounted once at the
 * app root, above all chrome.
 */
export function WorkspaceSwitchOverlay() {
  const isSwitching = useContextStore((s) => s.isSwitching);
  if (!isSwitching) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Switching workspace"
      className="animate-fade-in fixed inset-0 z-[100] flex flex-col items-center justify-center gap-3 bg-bg"
    >
      <Loader2 size={22} className="animate-spin text-primary" aria-hidden />
      <Text variant="body-md" color="muted">Switching workspace…</Text>
    </div>
  );
}
